import { Component, OnInit, ViewChild, HostListener, AfterViewInit, OnDestroy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { ContactGridComponent } from '../contact-grid/contact-grid.component';
import { I18nService } from 'app/shared/services/i18n.service';
import { ContactsService } from 'app/profile/services/contacts.service';
import { Store, select } from '@ngrx/store';
import { UserDetails, SupplierContactMap } from 'app/profile/models/user.model';
import { GetSupplierProfileCurrentUser, GetSupplierProfile, GetTabPermissions } from 'app/profile/store/app.actions';
import { SelectCurrentUser, SelectSupplierProfile, SelectTabPermissions } from 'app/profile/store/app.selector';
import { Subscription } from 'rxjs';
import { SupplierPropertyValue, Supplier, SupplierBasicDetails, Permission, SupplierAddress, SupplierContact, SupplierBank, SupplierTax, SupplierDocument, SupplierEntity, SupplierContactPropertyValue, TabPermissions } from 'app/profile/models/supplier.model';
import { TslDialog } from '@tesla/ng-tds';
import { getNestedNode } from 'app/shared/utils/utils';
import { SupplierState } from 'app/profile/store/state/supplierstate.state';
import { Profile } from 'app/profile/models/profile.model';
import { SupplierStateService } from 'app/profile/services/supplierstate.service';

@Component({
    selector: 'manage-contact',
    templateUrl: './manage-contact.component.html',
    styleUrls: ['./manage-contact.component.css']
})

export class ManageContactComponent implements OnInit, AfterViewInit, OnDestroy {

    public isCurrentUserValid: boolean = true;
    public isPendingApproval: boolean = false;
    public supplierCodes: string[];
    public supplierLegalName: string;
    public selectedSupplierCode: string = null;
    public supplierPrimaryEmail: string = '';

    subscription: Subscription = null;
    supplierCode: string;
    userDetails: UserDetails = null;
    isPrimary: boolean;
    isProfileAdmin: boolean;
    profile: Profile = null;
    tabPermissions: TabPermissions;

    @ViewChild('contactgrid') contactGrid: ContactGridComponent;

    constructor(
        private dialog: TslDialog,
        private snackBar: MatSnackBar,
        private contactsService: ContactsService,
        private route: ActivatedRoute,
        public matDialog: MatDialog,
        private store: Store<SupplierState>,
        private translate: I18nService) {
        this.subscription = new Subscription();
    }

    ngOnInit() {
        this.initialLoad();
    }
    ngAfterViewInit() {

    }

    private initialLoad() {
        this.route.parent.params.subscribe(params => {
            if (!params["code"]) {
                return;
            }

            this.supplierCode = params["code"];
            this.selectedSupplierCode = this.supplierCode;
            this.store.dispatch(new GetSupplierProfileCurrentUser());
            this.store.dispatch(new GetSupplierProfile(this.supplierCode));
            this.store.dispatch(new GetTabPermissions(this.supplierCode));
            const user = this.store.pipe(select(SelectCurrentUser)).subscribe(result => {
                if (result) {
                    this.userDetails = result;
                    if (this.userDetails.supplierContact && this.userDetails.supplierContact.supplierMaps) {
                        let supplierMap: SupplierContactMap = this.userDetails.supplierContact.supplierMaps.find(x => x.supplierCode == this.supplierCode) as SupplierContactMap;
                        this.isPrimary = supplierMap.userRoles.some(x => x.role.toLocaleLowerCase() === "primary");
                        this.isProfileAdmin = supplierMap.userRoles.some(x => x.role.toLocaleLowerCase() === "profile admin");
                    }

                    this.loadData(false);
                }
            });
            const supplierProfile = this.store.pipe(select(SelectSupplierProfile)).subscribe(res => {
                if (res) {
                    this.profile = res;
                }
            });

            const selectTabPermission = this.store.pipe(select(SelectTabPermissions)).subscribe(tabPermissions => this.tabPermissions = tabPermissions);

            this.subscription.add(selectTabPermission);
            this.subscription.add(supplierProfile);
            this.subscription.add(user);
        });
    }

    loadData(isReload: boolean) {

        if (isReload === true) {
            this.contactGrid.initLoad(true);
        }

    }

    @HostListener('window:beforeunload')
    canDeactivate(): boolean {
        if (this.contactGrid && this.contactGrid.SupplierContactList &&
            this.contactGrid.SupplierContactList.filter(x => x.isTouched).length > 0) {
            return false;
        }
        return true;
    }

    submitChanges() {
        if (this.userDetails && (this.isProfileAdmin || this.isPrimary) && this.tabPermissions && this.tabPermissions.contact == 'ReadWrite') {
            this.submit();
        }
    }

    submit() {
        var supplier = new SupplierPropertyValue();
        supplier.contacts = this.contactGrid.SupplierContactList;
        if (this.selectedSupplierCode && this.profile && this.profile.supplierDetails && supplier.contacts.filter(x => x.isTouched).length > 0) {

            supplier.contacts = supplier.contacts.filter(x => x.isTouched);
            var supplierDetails = this.pickNewValues(supplier);
            var supplierCategory = this.profile.supplierDetails.supplierCategory;

            if (supplierDetails.Contacts && supplierDetails.Contacts.length > 0) {
                supplierDetails.Contacts.forEach(x => {
                    if (x.ID === null) {
                        x.ID = 0;
                    }
                });
            }
            if (supplierCategory.some(x => x.name.toLowerCase() === 'direct') && this.directSupplier(this.contactGrid.SupplierContactList) === false) {
                this.dialog.alert(this.translate.get('Error'), this.translate.get('There should be at least one material planning contact!'));
            }
            else {
                this.contactsService.processContactChange(this.selectedSupplierCode, supplierDetails.Contacts).subscribe(evtResult => {
                    if (evtResult) {
                        if (evtResult.messages && evtResult.messages.filter(x => x.status === 'Error').length === 0) {
                            this.loadData(true);
                            this.snackBar.open('Success!', null, {
                                duration: 5000,
                                verticalPosition: 'top',
                                panelClass: ['blue-snackbar']
                            });
                        } else {
                            console.log('Error occurred while posting contact change event.', evtResult.messages);
                            this.ShowError('Error occurred while changing contact');
                        }
                    }
                    else {
                        console.log('Error occurred while posting contact change event.', evtResult.messages);
                        this.ShowError('Error occurred while posting contact change');
                    }

                }, err => {
                    console.error(`Service call error: processContactChange service call could not be completed. Details: ` + err);
                    this.ShowError(JSON.parse(err.Message).error.message);

                });
            }
        } else {
            this.dialog.alert('Error', 'No changes to submit!');
        }
    }

    pickNewValues(supplierData: SupplierPropertyValue): Supplier {
        if (!supplierData) {
            return null;
        }
        const supplier = new Supplier();
        if (supplierData.details) {
            supplier.Details = new SupplierBasicDetails();
            Object.keys(supplierData.details).forEach(name => {
                if (getNestedNode([name, 'isTouched'], supplierData.details) &&
                    getNestedNode([name, 'permission'], supplierData.details) === Permission.ReadWrite) {
                    supplier.Details[name] = getNestedNode([name, 'newValue'], supplierData.details);
                }
            });
        }

        if (supplierData.addresses) {
            supplier.Addresses = [];
            supplierData.addresses.forEach((address, index) => {
                supplier.Addresses[index] = new SupplierAddress();
                Object.keys(address).forEach(name => {
                    supplier.Addresses[index][name] = getNestedNode([name, 'newValue'], address);
                });
                supplier.Addresses[index].Operation = address.operation.newValue ? address.operation.newValue : null;
            });
        }

        if (supplierData.contacts) {
            supplier.Contacts = [];
            supplierData.contacts.forEach((contact, index) => {
                supplier.Contacts[index] = new SupplierContact();
                Object.keys(contact).forEach(name => {
                    supplier.Contacts[index][name] = getNestedNode([name, 'newValue'], contact);
                });
                supplier.Contacts[index].Operation = contact.operation.newValue ? contact.operation.newValue : null;
            });
        }

        if (supplierData.banks) {
            supplier.Banks = [];
            supplierData.banks.forEach((bank, index) => {
                supplier.Banks[index] = new SupplierBank();
                Object.keys(bank).forEach(name => {
                    supplier.Banks[index][name] = getNestedNode([name, 'newValue'], bank);
                });
                supplier.Banks[index].Operation = bank.operation.newValue ? bank.operation.newValue : null;
            });
        }

        if (supplierData.taxes) {
            supplier.Taxes = [];
            supplierData.taxes.forEach((tax, index) => {
                supplier.Taxes[index] = new SupplierTax();
                Object.keys(tax).forEach(name => {
                    supplier.Taxes[index][name] = getNestedNode([name, 'newValue'], tax);
                });
                supplier.Taxes[index].Operation = tax.operation.newValue ? tax.operation.newValue : null;
            });
        }

        if (supplierData.documents) {
            supplier.Documents = [];
            supplierData.documents.forEach((document, index) => {
                supplier.Documents[index] = new SupplierDocument();
                Object.keys(document).forEach(name => {
                    supplier.Documents[index][name] = getNestedNode([name, 'newValue'], document);
                });
                supplier.Documents[index].Operation = document.operation.newValue ? document.operation.newValue : null;
            });
        }

        if (supplierData.entities) {
            supplier.Entities = [];
            supplierData.entities.forEach((document, index) => {
                supplier.Entities[index] = new SupplierEntity();
                Object.keys(document).forEach(name => {
                    supplier.Entities[index][name] = getNestedNode([name, 'newValue'], document);
                });
                supplier.Entities[index].Operation = document.operation.newValue ? document.operation.newValue : null;
            });
        }

        return supplier;
    }

    //Raise success or failure message maximum height and width
    ShowMessage(message: string) {
        this.translate.getAsync(message).subscribe((x: string) => {
            this.snackBar.open(x, '', {
                duration: 5000,
                verticalPosition: 'top',
                panelClass: ['blue-snackbar']
            });
        });
    }

    ShowError(message: string) {
        this.translate.getAsync(message).subscribe((x: string) => {
            this.snackBar.open(x, '', {
                duration: 5000,
                verticalPosition: 'top',
                panelClass: ['red-snackbar']
            });
        });
    }

    directSupplier(dataItem: SupplierContactPropertyValue[]): boolean {
        var result = false;
        dataItem.forEach(x => {
            if (x.types.newValue.includes('Material Planning')) {
                result = true;
            }
        });
        return result;
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}